<template>
  <el-popover placement="bottom" width="600" v-model="visible">

    <el-button slot="reference">选择项目</el-button>


    <div class="el-transfer ips-transfer-project__tree">
      <div class="el-transfer-panel">
        <p class="el-transfer-panel__header">
          <label class="el-checkbox">
            <span class="el-checkbox__label">
              项目列表
            </span>
          </label>
        </p>
        <div class="el-transfer-panel__body">
          <div class="el-checkbox-group el-transfer-panel__list">
            <el-tree
              ref="tree"
              :props="props"
              :load="loadNode"
              :default-checked-keys="keys"
              node-key="id"
              lazy
              show-checkbox>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="el-transfer__buttons">
        <el-button class="el-transfer__button" icon="el-icon-arrow-left" :disabled="leftBtnDisable"
                   @click="unSelectProject"></el-button>
        <el-button class="el-transfer__button" icon="el-icon-arrow-right" :disabled="rightBtnDisable"
                   @click="selectProject"></el-button>
      </div>
      <div class="el-transfer-panel">
        <p class="el-transfer-panel__header">
          <label class="el-checkbox">
            <span class="el-checkbox__label">
              已选列表
              <span>{{preDelProCount}}/{{projectsCount}}</span>
            </span>
          </label>
        </p>
        <div class="el-transfer-panel__body">
          <div class="el-checkbox-group el-transfer-panel__list">

            <el-checkbox class="el-transfer-panel__item" v-for="project in cacheProjects" :key="project.id"
                         v-model="project.checked">
              {{project.name}}
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="txt-right mgt-10">
      <el-button @click="cancel"> 取消</el-button>
      <el-button type="primary" @click="finish"> 确定</el-button>
    </div>
  </el-popover>
</template>

<script>
  import {AD_PATH} from "../store/action-path";
  import qs from 'qs';
  import _ from 'lodash';

  export default {
    name: "TransferProjectTree"
    , props: ["projects"]
    , data() {
      return {
        visible: false
        , allChecked: false
        , cacheProjects: []
        , props: {
          label: "name"
          , isLeaf: 'leaf'
        }
      }
    }

    , computed: {
      keys() {
        let keys = [];
        this.cacheProjects.forEach(item => {
          keys.push(item.id)
        });
        return keys
      }

      , projectsCount() {
        return this.cacheProjects.length
      }

      , preDelProCount() {
        return (this.cacheProjects.filter(item => item.checked)).length
      }

      , leftBtnDisable() {
        return this.preDelProCount < 1
      }

      , rightBtnDisable() {
        return false
      }

    }
    , methods: {
      loadNode(node, resolve) {

        let url = `${AD_PATH}/core/admin/advertising/city/etc/tree`;
        let self = this;
        if (node.level === 0) {
          this.axios.post(url + '?parentId=0&type=1').then(result => {
            resolve(result.data)
          });
        } else {
          let params = {
            parentId: node.data.id,
            type: node.level + 1
          };
          let headers = {'Content-Type': 'application/x-www-form-urlencoded'};
          this.axios.post(url, qs.stringify(params), {headers}).then(result => {
            let treeData = result.data;
            if (node.level === 2) {
              treeData.forEach((item) => {
                item.leaf = true;
                // 如果原有广告上有选择过该项目,加载出来后自动将该项目勾选上
                item.checked = self.keys.indexOf(item.id) > -1;
              })
            }
            resolve(treeData)
          })
        }
      }
      , cancel() {
        this.visible = false;
      }
      , finish() {
        this.$emit('selected', this.cacheProjects);
        this.visible = false;
      }
      , setCheckedNodes() {
        this.projects.forEach(item => {
          this.$refs.tree.setChecked(item.id, true, true)
        })
      }

      , unSelectProject() {
        this.cacheProjects = this.cacheProjects.filter(item => !item.checked);
        this.$refs.tree.setCheckedNodes(this.cacheProjects);
      }

      , selectProject() {
        let treeNodes = this.$refs.tree.getCheckedNodes(true, false);
        let tempArr = this.cacheProjects.concat(treeNodes);
        this.cacheProjects = _.uniqBy(tempArr, item => item.id);
      }
    }

    , watch: {
      visible(newVal) {
        if (newVal) {
          this.$refs.tree.setCheckedNodes(this.cacheProjects)
        } else {
          // 把父组件的定义为选中的项目再次选中
          // this.projects.forEach(item => {
            // this.$refs.tree.setChecked(item.id, true, true)
          // })
        }
      }

      , projects(newVal) {
        this.cacheProjects = [];
        if (_.isArray(newVal)) {
          // 复制 projects 数组因为选择项目的操作需要修改 projects 数组,直接操作不方便
          this.projects.forEach(item => {
            //为每一个项目都创建一个 checked 属性, 方便选择操作
            this.cacheProjects.push(_.extend({checked: false}, item))
          })
        }


      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/transfer";
</style>